export default "__VITE_PUBLIC_ASSET__f50c96ab__"